import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';

import { GlobalState } from 'ha/types/store';
import { FavoriteListing } from 'ha/services/apiV2/types/FavoriteListing';
import reportError from 'ha/helpers/bugsnag/reportError';
import { getUserId, getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Options } from 'ha/services/apiV2/getFavoriteListings';

export const enum ActionTypes {
  START = '[favorites] LOAD_FAVORITES',
  DONE = '[favorites] LOAD_FAVORITES_DONE',
  FAIL = '[favorites] LOAD_FAVORITES_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (favorites: FavoriteListing[]) =>
    createAction(ActionTypes.DONE, favorites),
  fail: () => createAction(ActionTypes.FAIL),
};
export type Actions = ActionsUnion<typeof Actions>;

type FetchFavoriteListings = (options?: Options) => Thunk<GlobalState>;

const getFavoriteListings: FetchFavoriteListings = options => (
  dispatch,
  getState,
  { apiV2 },
) => {
  const state = getState();

  if (!getIsAuthenticated(state)) {
    return Promise.resolve();
  }

  dispatch(Actions.start());

  return apiV2
    .getFavoriteListings(getUserId(state)!, options)
    .then(({ data }) => {
      dispatch(Actions.done(data.favorites));
    })
    .catch(error => {
      reportError(error);
      dispatch(Actions.fail());
    });
};

export default getFavoriteListings;
